module.exports = __webpack_public_path__ + "img/pa.cd77594.webp";